import {
  Box,
  Grid,
  Typography,
  Switch,
  TableContainer,
  Table,
  TableBody,
} from "@mui/material";
import { NotificationConfiguration } from "../types";
import UserNotificationConfigurationToggle from "./userNotificationConfigurationToggle";
import { useState } from "react";
import CardBox from "../../../main/components/CardBox";
import PrimaryBaseButton from "../../../main/components/PrimaryBaseButton";
import DangerBaseButton from "../../../main/components/DangerBaseButton";
import ConfirmationDialogUser from "./ConfirmationDialogUser";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";
import { usersApi } from "../../../services/api";

export function UserDetailsNotificationToggleItems(props: {
  configuration: NotificationConfiguration;
  setConfiguration: React.Dispatch<
    React.SetStateAction<NotificationConfiguration | undefined>
  >;
  label: string;
  defaultConfiguration: NotificationConfiguration;
  userId: string;
  onMount: () => void;
}) {
  const {
    configuration,
    label,
    setConfiguration,
    defaultConfiguration,
    userId,
    onMount,
  } = props;

  const [isCancelConfirmationOpen, setCancelConfirmationOpen] =
    useState<boolean>(false);
  const handleConfirmCancel = () => {
    setConfiguration(defaultConfiguration);
    setCancelConfirmationOpen(false);
  };
  const [isSaveConfirmationOpen, setSaveConfirmationOpen] =
    useState<boolean>(false);
  const [openSuccessModal, setOpenSuccessModal] = useState<boolean>(false);
  const [openErrorModal, setOpenErrorModal] = useState<boolean>(false);
  const handleConfirmSave = async () => {
    try {
      await usersApi.notificationConfiguration(userId, configuration);
      setSaveConfirmationOpen(false);
      setOpenSuccessModal(true);
    } catch (error) {
      setOpenErrorModal(true);
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        width: "100%",
        columnGap: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          columnGap: "10px",
          alignItems: "center",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: "16px",
          }}
        >
          {label}
        </Typography>
        <Box
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "14px",
            }}
          >
            {configuration.notificationsEnabled
              ? "Desabilitar Notificações"
              : "Habilitar Notificações"}
          </Typography>
          <Switch
            checked={configuration.notificationsEnabled}
            onChange={(_, checked) =>
              setConfiguration({
                ...configuration,
                notificationsEnabled: checked,
              })
            }
            inputProps={{ "aria-label": "controlled" }}
          />
        </Box>
      </Box>
      <Grid
        container
        sx={{
          display: "flex",
          rowGap: "20px",
          width: "100%",
          marginTop: "15px",
        }}
      >
        <CardBox
          sx={{
            width: "100%",
            height: "200px",
            maxHeight: "200px",
            overflow: "auto",
          }}
        >
          <TableContainer
            sx={{ display: "flex", alignItems: "flex-start", height: "100%" }}
          >
            <Table size="small" stickyHeader>
              <TableBody>
                <UserNotificationConfigurationToggle
                  disabled={!configuration.notificationsEnabled}
                  configurationType={configuration.reportMonthlyConfiguration}
                  configurationName="reportMonthlyConfiguration"
                  configuration={configuration}
                  setConfiguration={setConfiguration}
                  title="Relatório Mensal"
                />
                <UserNotificationConfigurationToggle
                  disabled={!configuration.notificationsEnabled}
                  configurationType={configuration.reportDailyConfiguration}
                  configurationName="reportDailyConfiguration"
                  configuration={configuration}
                  setConfiguration={setConfiguration}
                  title="Boletim Diário"
                />
                <UserNotificationConfigurationToggle
                  disabled={!configuration.notificationsEnabled}
                  configurationType={configuration.reportPartialConfiguration}
                  configurationName="reportPartialConfiguration"
                  configuration={configuration}
                  setConfiguration={setConfiguration}
                  title="Relatório Parcial"
                />
                <UserNotificationConfigurationToggle
                  disabled={!configuration.notificationsEnabled}
                  configurationType={configuration.alarmsBlandConfiguration}
                  configurationName="alarmsBlandConfiguration"
                  configuration={configuration}
                  setConfiguration={setConfiguration}
                  title="Alarmes Leves"
                />

                <UserNotificationConfigurationToggle
                  disabled={!configuration.notificationsEnabled}
                  configurationType={configuration.alarmsMediumConfiguration}
                  configurationName="alarmsMediumConfiguration"
                  configuration={configuration}
                  setConfiguration={setConfiguration}
                  title="Alarmes Médios"
                />
                <UserNotificationConfigurationToggle
                  disabled={!configuration.notificationsEnabled}
                  configurationType={configuration.alarmsSevereConfiguration}
                  configurationName="alarmsSevereConfiguration"
                  configuration={configuration}
                  setConfiguration={setConfiguration}
                  title="Alarmes Severos"
                />
              </TableBody>
            </Table>
          </TableContainer>
        </CardBox>
      </Grid>
      {JSON.stringify(defaultConfiguration) !==
        JSON.stringify(configuration) && (
          <Grid
            sx={{
              paddingTop: "8px",
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
            item
            xs={12}
          >
            <DangerBaseButton
              onClick={() => setCancelConfirmationOpen(true)}
              title="Descartar"
              sx={{ height: "35px", marginRight: "8px" }}
            />
            <PrimaryBaseButton
              title="Salvar"
              onClick={() => setSaveConfirmationOpen(true)}
              sx={{ height: "35px" }}
            />
          </Grid>
        )}
      <ConfirmationDialogUser
        open={isCancelConfirmationOpen}
        title="Descartar alteração"
        message="Deseja descartar as alterações?"
        onConfirm={handleConfirmCancel}
        onCancel={() => setCancelConfirmationOpen(false)}
        onClose={() => setCancelConfirmationOpen(false)}
      />
      <ConfirmationModal
        open={isSaveConfirmationOpen}
        setOpen={() => setSaveConfirmationOpen(false)}
        title="Salvar Notificações"
        contentText="Deseja confirmar a edição das notificações ?"
        onConfirm={handleConfirmSave}
      />
      <ActionAlert
        message="As notificações foram atualizados com sucesso!"
        severity="success"
        open={openSuccessModal}
        setOpen={() => setOpenSuccessModal(false)}
        onClose={onMount}
      />
      <ActionAlert
        message="Ocorreu um erro no modo de edição! Tente novamente mais tarde."
        severity="error"
        open={openErrorModal}
        setOpen={setOpenErrorModal}
      />
    </Box>
  );
}
